// Layout
const dashboardLayout = () => import('@/layouts/DriverLayout/DashboardLayout/dashboardLayout.vue')

const processing = () => import('./views/index')

// start Routes
export default [
  {
    path: '/driver/processing',
    component: dashboardLayout,
    children: [{
      path: '',
      name: 'driverProcessing',
      meta: {
        name: 'driverProcessing',
        parentName: 'processing',
        userType: '',
        permission: '',
        role: 'transportation.driver'
      },
      component: processing
    }
    ]
  }
]
